export default __webpack_public_path__ + "static/media/022-statue of liberty.4f2b74f7.svg";